export const SITE_TYPE = "WORDPRESS";
